export interface Testimonial {
  quote: string
  name: string
  role: string
}

// NOTE (Lucas): placeholder testimonials — replace with real reviews before going live.
export const testimonials: Testimonial[] = [
  {
    quote: '“This is exactly what I needed. My whole year is finally mapped out.”',
    name: 'Sarah M.',
    role: 'Grade 4 Teacher',
  },
  {
    quote: '“The answer keys alone save me hours every single week.”',
    name: 'David R.',
    role: 'Middle School Math',
  },
  { quote: '“My students actually ask for the project days now.”', name: 'Elena T.', role: 'Grade 7 Teacher' },
  {
    quote: '“I teach three grade levels and everything finally lines up.”',
    name: 'James T.',
    role: 'Multi-Grade Teacher',
  },
  {
    quote: '“The scope and sequence made my Common Core planning simple.”',
    name: 'Aisha K.',
    role: 'Grade 2 Math Lead',
  },
  {
    quote: '“Prep went from two hours a week to printing the next unit.”',
    name: 'Marco R.',
    role: 'Homeschool Parent',
  },
]
